import React, { useContext, useEffect, useState } from 'react';
import EditableGroup, { EditableGroupType } from '../../../components/editable/EditableGroup/EditableGroup';
import { RequestStatus, WalkaroundOption, api } from '../../../logic/api';
import EditableField, { EditableFieldTypes } from '../../../components/editable/EditableField/EditableField';
import { Button } from '@mui/material';
import { SessionContext } from '../../../utility/useSession';
import { ProgressDialog } from '../../../components/notifications/progressDialog/progressDialog';
import ErrorDialog from '../../../components/notifications/errorDialog/ErrorDialog';
import AlertDialog from '../../../components/notifications/alertDialog/AlertDialog';
import { useTranslation } from 'react-i18next';

export const WaOptions: React.FC = () => {
    const session = useContext(SessionContext);
    const save = api.hooks.walkaroundOptions.save();
    const get = api.hooks.walkaroundOptions.get();
    const { t } = useTranslation();

    const [state, setState] = useState<WalkaroundOption>({
        config: {},
    });

    useEffect(() => {
        get.send(session.current.context, {});
    }, [session.current.site]);

    useEffect(() => {
        setState(get.data ?? { config: {} });
    }, [get.data]);

    const updateOptions = async (data: WalkaroundOption) => {
        setState(data);
        return true;
    };

    const handleSaveChanges = () => {
        save.send(session.current.context, state, (s) => {
            if (s != null) {
                setState(s);
            }
        });
    }

    return <div style={{ textAlign: "center" }}>
        <div style={{ width: "100%", maxWidth: 800, display: "inline-block" }}>
            <div style={{ textAlign: "left" }}><h2>{t("reports.content")}</h2></div>
            <EditableGroup<WalkaroundOption>
                id="wa_checklistitems_inline"
                testId="walkaround-options-group"
                editType={EditableGroupType.alwaysEditing}
                data={state}
                onDataChanged={(data) => updateOptions(data)}>
                <EditableField<WalkaroundOption, string>
                    inputType={EditableFieldTypes.textMultiLine}
                    label={t("walkarounds.driverNotice")}
                    required={true}
                    columnWidth={12}
                    maxLength={200}
                    maxWidth={1200}
                    showCharacterCount={true}
                    useFullWidthWhenEditing={true}
                    onProvide={(data) => data.config.driverNotice ?? ""}
                    onChange={(data, value) => data.config.driverNotice = value}
                />
                <EditableField<WalkaroundOption, string>
                    inputType={EditableFieldTypes.textMultiLine}
                    label={t("walkarounds.instructions")}
                    useFullWidthWhenEditing={true}
                    maxLength={1000}
                    maxWidth={1200}
                    columnWidth={12}
                    showCharacterCount={true}
                    required={true}
                    onProvide={(data) => (data.config.driverInstructions ?? "")}
                    onChange={(data, value) => data.config.driverInstructions = (value ?? "")} />
            </EditableGroup>
            <div style={{ textAlign: "right" }}>
                <Button
                    style={{ marginLeft: 20, marginTop: 20, marginBottom: 50, width: 200 }}
                    variant="contained"
                    color="secondary"
                    onClick={handleSaveChanges}>{t("webhooks.saveChanges")}</Button>
            </div>
        </div>
        <ProgressDialog status={save.status}></ProgressDialog>
        <ErrorDialog err={save.err}></ErrorDialog>
        <AlertDialog show={save.status == RequestStatus.loaded && save.data != null} title={t("walkarounds.saved")} message={t("walkarounds.walkaroundSaved")} />
    </div>
}
